var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-chart-container h-100"},[_c('GChart',{staticClass:"bargraph",attrs:{"type":"ColumnChart","data":_vm.chartData,"options":_vm.getChartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }